import TopBar from "../../../components/LayoutComponent/TopBar/topBar";
import Tabbar from "../../../components/LayoutComponent/TabBar/Tabbar";
import "../userDashboard.css";
import ShortsCarousel from "../../../components/BookComponents/ShortsCarousel";

export const UserShortsPage = () => {
  return (
    <>
      {/* <TopBar displayType="logo" showNotification showProfileBtn></TopBar> */}
      <ShortsCarousel></ShortsCarousel>
      <Tabbar menuType={"users"}></Tabbar>
    </>
  );
};

export default UserShortsPage;
